import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';
import Iconify from 'src/components/iconify';
import { TDeviceType } from 'src/static/constants/common/device';

interface DeviceToggleProps {
  device: TDeviceType;
  onDeviceChange: (event: React.MouseEvent<HTMLElement>, newDeviceType: TDeviceType) => void;
}

export const DeviceToggle = ({ device, onDeviceChange }: DeviceToggleProps) => {
  return (
    <StyledToggleButtonGroup
      value={device}
      exclusive
      onChange={onDeviceChange}
      aria-label="device type"
      size="small"
    >
      <ToggleButton value="desktop" aria-label="desktop">
        <Iconify icon="mdi:desktop-mac" />
      </ToggleButton>
      <ToggleButton value="tablet" aria-label="tablet">
        <Iconify icon="mdi:tablet" />
      </ToggleButton>
      <ToggleButton value="mobile" aria-label="mobile">
        <Iconify icon="mdi:cellphone" />
      </ToggleButton>
    </StyledToggleButtonGroup>
  );
};

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  '& .MuiToggleButton-root': {
    padding: '6px 12px',
    border: 'none',
    '&:not(:last-child)': {
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  },
}));
